import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const CreateOrderDateCellContent: React.FC<
	CreateOrderDateCellContent.Props
> = ({ item }) => {
	const { dateFns } = useAppContext();

	const content = useMemo(
		() => cellProcessing(item.createdAt, dateFns),
		[item.createdAt, dateFns],
	);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CreateOrderDateCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default CreateOrderDateCellContent;
